import * as React from 'react';
import MainLayout from '@/layouts/MainLayout';
import { useGetCampaigns, useCreateCampaign } from '../../react-query/outreach-queries';
import CampaignsTable from '../../components/outreach/CampaignsTable';
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export default function OutreachCampaignsPage() {
  const { data: campaigns, isLoading } = useGetCampaigns();
  const { mutate: createCampaign, isPending } = useCreateCampaign();
  const [open, setOpen] = React.useState(false);
  
  const [name, setName] = React.useState('');
  const [description, setDescription] = React.useState('');

  const handleCreate = () => {
    if (!name) return;
    createCampaign({ name, description }, {
        onSuccess: () => {
            setOpen(false);
            setName('');
            setDescription('');
        }
    });
  };

  return (
    <MainLayout>
      <div className="flex bg-slate-50 min-h-[calc(100vh-64px)]">
        <main className="flex-1 p-6 md:p-8 max-w-7xl mx-auto space-y-6">
          <div className="w-full mb-8">
            <div className="flex justify-between items-center mb-6">
              <h1 className="text-3xl font-bold tracking-tight text-gray-900">
                  Campaigns
              </h1>
              <Dialog open={open} onOpenChange={setOpen}>
                  <DialogTrigger asChild>
                      <Button>New Campaign</Button>
                  </DialogTrigger>
                  <DialogContent className="sm:max-w-[425px]">
                      <DialogHeader>
                          <DialogTitle>Create New Campaign</DialogTitle>
                          <DialogDescription>
                              Create a campaign to organize your podcast outreach.
                          </DialogDescription>
                      </DialogHeader>
                      <div className="grid gap-4 py-4">
                          <div className="grid grid-cols-4 items-center gap-4">
                              <Label htmlFor="name" className="text-right">
                                  Name
                              </Label>
                              <Input
                                  id="name"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  className="col-span-3"
                              />
                          </div>
                          <div className="grid grid-cols-4 items-center gap-4">
                              <Label htmlFor="description" className="text-right">
                                  Description
                              </Label>
                              <Textarea
                                  id="description"
                                  value={description}
                                  onChange={(e) => setDescription(e.target.value)}
                                  className="col-span-3"
                              />
                          </div>
                      </div>
                      <DialogFooter>
                          <Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
                          <Button onClick={handleCreate} disabled={!name || isPending}>Create</Button>
                      </DialogFooter>
                  </DialogContent>
              </Dialog>
            </div>

            {isLoading ? (
              <div className="text-center py-10 text-muted-foreground">Loading...</div>
            ) : (
              <CampaignsTable rows={campaigns || []} />
            )}
          </div>
        </main>
      </div>
    </MainLayout>
  );
}
